import { useState } from "react";
import { createMessage } from "./messages";

export default function MessageForm({ onRefresh }) {
  const [form, setForm] = useState({
    title: "",
    message: "",
    type: "announcement",
    force_show: false,
  });

  const submit = async () => {
    await createMessage(form);
    setForm({
      title: "",
      message: "",
      type: "announcement",
      force_show: false,
    });

    onRefresh();
  };

  return (
    <div>
      <h2>Create Message</h2>

      <input
        placeholder="Title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      <textarea
        placeholder="Message"
        value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })}
      />

      <select
        value={form.type}
        onChange={(e) => setForm({ ...form, type: e.target.value })}
      >
        <option value="maintenance">Maintenance</option>
        <option value="update">Update</option>
        <option value="feature">Feature</option>
        <option value="announcement">Announcement</option>
      </select>

      <label>
        <input
          type="checkbox"
          checked={form.force_show}
          onChange={(e) =>
            setForm({
              ...form,
              force_show: e.target.checked,
            })
          }
        />
        Force Show (Cannot dismiss)
      </label>

      <button onClick={submit}>Send Message</button>
    </div>
  );
}
